export default {
  "l10n": {
    "date": {
      "months": {
        "full": ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],
        "abbr": ["ene.","feb.","mar.","abr.","may.","jun.","jul.","ago.","sep.","oct.","nov.","dic."]
      },
      "days": {
        "full": ["domingo","lunes","martes","miércoles","jueves","viernes","sábado"],
        "abbr": ["do.","lu.","ma.","mi.","ju.","vi.","sá."]
      },
      "patterns": {
        "longDate": "dddd, D MMMM YYYY",
        "dateSlash": "DD/MM/YYYY",
        "dateShort": "dddd D MMMM",
        "dateMedium": "dddd D MMMM - H[:]mm [h]",
        "dateLarge": "dddd D MMMM [a las] HH[:]mm:ss [h]",
        "timeShort": "LT",
        "timeMedium": "DD[/]MM LT"
      }
    },
    "number": {
      "patterns": {
        "standard": ["-n", "n"],
        "amount": ["-nS", "nS"]
      },
      "group": {
        "separator": ".",
        "length": 3,
        "abbr": ["", "k", "M", "B"]
      },
      "decimal": {
        "separator": ",",
        "length": 2
      },
      "ordinal": function(number) { return number + (number === 1 ? '°' : '°'); }
    }
  },
  "translations": {
    "messages": {
  " CASH ": [
    null,
    ""
  ],
  "!action:Deposit": [
    null,
    "Depositar"
  ],
  "!desc:AddCitizenCard": [
    null,
    ""
  ],
  "!desc:BetRefundOffer": [
    null,
    "Primeira aposta reembolsada até 100€<br /><br />Para lhe dar as boas-vindas à Winamax, oferecemos duas ofertas: um bônus de até 200€ e uma aposta reembolsada de até 150€*! As duas ofertas são cumulativas e são ativadas automaticamente com seu primeiro depósito na plataforma. Bônus de até 200€. Se a sua primeira aposta esportiva feita na Winamax for perdedora, você receberá uma aposta grátis do mesmo valor. Limitado ao valor do seu primeiro depósito e até um máximo de 100€.<br /><br />Por exemplo: você faz um primeiro depósito de 50€ na Winamax e aposta no Atlético de Madri para vencer a Juventus. Se o Atlético não vencer, você receberá uma aposta grátis de 50€ em sua conta Winamax."
  ],
  "!desc:BetRefundOffer100": [
    null,
    "Oferta do primeiro depósito, até 100€ <br /> <br /> Para comemorar a sua chegada à Winamax, irá beneficiar de duas ofertas de boas-vindas quando realizar o seu primeiro depósito: um bônus de até 250€ e a oferta do valor do seu primeiro depósito em Freebets, até € 100€*! Poderá começar a apostar em desportos imediatamente. <br /> <br /> As 2 ofertas são cumulativas e realizadas automaticamente quando fizer o seu primeiro depósito, se assim o desejar."
  ],
  "!desc:CondBetRefundOffer": [
    null,
    "* Antes de qualquer saque, o valor de depósito inicial deve ser utilizado em apostas esportivas na Winamax (no limite de 100€ se este for superior) com o seu saldo de dinheiro real. Esta ação pode ser feita ao realizar uma ou várias apostas (exceto Freebets). A apostas canceladas ou apostas Cashout não serão contabilizadas."
  ],
  "!desc:CondFirstDeposit": [
    null,
    "* A oferta de primeiro depósito é válida apenas uma vez por usuário, dispositivo (computador, tablet ou telefone), endereço ou conta bancária. Ela é reservada aos jogadores que nunca fizeram um depósito em uma conta Winamax (incluindo uma que tenha sido fechada)."
  ],
  "!desc:DefaultLandingContent": [
    null,
    "\t\n<h1>Cadastre-se na Winamax gratuitamente</h1>\n<p>\nRegistre-se agora para aproveitar vantagens incríveis.<br/><br/>\n<div >\n  <ul style=\"margin-left: 20px\">\n      <li>\n          <b> Apostas esportivas</b> <br/>\n          \n          Crie sua aposta e obtenha cotas totalmente personalizadas com MyMatch.<br/><br/>\n      </li><li>\n          <b>Os Freerolls: 12 torneios gratuitos todos os dias</b><br/>\n          \n          Descubra nosso software de Poker participando de torneios gratuitos, com 1500 € em prêmios todos os dias! <br/><br/>\n      </li><li class=\"hide-for-small\">     \n          <b>Site 100% seguro</b><br/>\n          Jogue de forma segura em nosso software autorizado pela Dirección General de Ordenación del Juego (DGOJ) da Espanha. <br/><br/>\n      </li>\n  </ul>\n</div>\n</p>\n"
  ],
  "!desc:DefaultLandingContentES": [
    null,
    "<h1>Registre-se na Winamax gratuitamente</h1>\n<p>\nRegistre-se agora para se beneficiar de vantagens excepcionais.<br/><br/>\n<div >\n  <ul style=\"margin-left: 20px\">\n      <li>\n          <b>Apostas esportivas</b> <br/>\n          \n          Crie sua aposta e obtenha cotas totalmente personalizadas com MyMatch.<br/><br/>\n      </li><li>\n          <b>Os Freerolls: 12 torneios gratuitos todos os dias</b><br/>\n          \n          Descubra nosso software de poker participando de torneios gratuitos - com 1500 € em prêmios todos os dias! <br/><br/>\n      </li><li class=\"hide-for-small\">     \n          <b>Site 100% seguro </b><br/>\n          Jogue de forma segura em nosso software autorizado pela Dirección General de Ordenación del Juego (DGOJ) da Espanha. <br/><br/>\n      </li>\n  </ul>\n</div>"
  ],
  "!desc:DefaultLandingMobileContent": [
    null,
    "<h2> Como funciona? </h2>\n<br />\n<p> Quando realizar o seu primeiro depósito na Winamax, e antes qualquer ação de jogo, oferecemos-lhe o montante do seu depósito em bônus de apostas esportivas até 100 €.\n<br />\nPor exemplo, se depositar 100€ na Winamax, receberá imediatamente 100€ em bônus de apostas esportivas na sua conta para começar a apostar.\n<br />\nTambém lhe oferecemos um bônus no valor do seu depósito até 250€. A sua conta Winamax será creditada em parcelas de 20% do valor do bônus cada vez que tiver ganho Milhas suficientes (Milhas são pontos de fidelidade obtidos ao jogar poker e realizar apostas desportivas). Por cada euro de bônus, terá de ganhar 30 milhas. Por exemplo, se tiver realizado o primeiro depósito no valor de 100€, creditar-lhe-emos 20€ quando atingir 600 Milhas, depois outros 20€ quando atingir 1.200 Milhas, etc. Receberá um total de 100€ assim que tiver acumulado Milhas suficientes. No total, receberá 100€ após ter obtido 3.000 Milhas.\n<br /><br />\n<p><small><i>* A oferta de primeiro depósito é válida apenas uma vez por usuário, dispositivo (computador, tablet ou telefone), endereço ou conta bancária. Ela é reservada aos jogadores que nunca fizeram um depósito em uma conta Winamax (incluindo uma que tenha sido fechada). <a href=\"/https://www.winamax.pt/bonus-primeiro-deposito\" target=\"_blank\"> Ver todas as condições </i></a>.</small></p>"
  ],
  "!desc:DefaultLandingPageTitleES": [
    null,
    "Junte-se a Winamax e desfrute das melhores cotas do mercado e de uma experiência única de jogar poker online."
  ],
  "!desc:DefaultLandingTitleES": [
    null,
    "A melhor oferta em apostas esportivas e poker"
  ],
  "!desc:SpecialOfferLandingContent": [
    null,
    ""
  ],
  "!desc:SpecialOfferLandingMobileContent": [
    null,
    ""
  ],
  "!placeholder:dd": [
    null,
    "dd"
  ],
  "!placeholder:mm": [
    null,
    "mm"
  ],
  "!placeholder:yy": [
    null,
    "aa"
  ],
  "!placeholder:yyyy": [
    null,
    "aaaa"
  ],
  ", if you lost": [
    null,
    ""
  ],
  "1st bet refunded up to €100": [
    null,
    "1ª aposta reembolsada até €100"
  ],
  "A photo of the back of your ID document will also be required to validate your account.": [
    null,
    "Uma foto do verso do seu documento de identidade também será necessária para validar sua conta."
  ],
  "A receipt for your rent": [
    null,
    "Um recibo do seu aluguel"
  ],
  "Above": [
    null,
    "Acima"
  ],
  "Acceptable ID": [
    null,
    "Documento de identidade aceitável"
  ],
  "Acceptable formats: %1$s.": [
    null,
    "Formatos aceitos: %1$s."
  ],
  "Acceptable proof of address documents": [
    null,
    "Comprovantes de residência aceitáveis"
  ],
  "Account already exist": [
    null,
    "Já existe uma conta com esse endereço de e-mail/número de telefone."
  ],
  "Account creation complete": [
    null,
    "Criação de conta concluída"
  ],
  "Account creation: complete.<br />That's what<br />we're talking about!": [
    null,
    "Criação de conta: concluída.<br />É disso que<br />estamos falando!"
  ],
  "Account number": [
    null,
    "Número da conta"
  ],
  "Activation code": [
    null,
    "Código de ativação"
  ],
  "Add a bank card": [
    null,
    "Adicionar um cartão do banco"
  ],
  "Add my bank card": [
    null,
    "Adicionar meu cartão do banco"
  ],
  "Add my bank card details": [
    null,
    "Adicionar meus dados do cartão do banco"
  ],
  "Address details": [
    null,
    "Detalhes do endereço"
  ],
  "All countries": [
    null,
    "Todos os países"
  ],
  "An error has occured when checking your CAPTCHA score. Please try again later.": [
    null,
    "Ocorreu uma erro ao verificar sua pontuação CAPTCHA. Por favor, tente novamente mais tarde."
  ],
  "Analysis": [
    null,
    "Análise"
  ],
  "Automatic withdrawal": [
    null,
    "Saque automático"
  ],
  "Automatic withdrawal threshold": [
    null,
    ""
  ],
  "BOOM! You can start playing!": [
    null,
    "BUM! Você pode começar a jogar!"
  ],
  "Back": [
    null,
    "Voltar"
  ],
  "Back to homepage": [
    null,
    "Voltar à página inicial"
  ],
  "Bank": [
    null,
    "Banco"
  ],
  "Bank accounts from this country are not accepted on Winamax": [
    null,
    "Contas bancárias deste país não são aceitas na Winamax"
  ],
  "Bank card number": [
    null,
    "Número do cartão do banco"
  ],
  "Bank code": [
    null,
    "Código do banco"
  ],
  "Bank details": [
    null,
    ""
  ],
  "Bank office": [
    null,
    "Agência do banco"
  ],
  "Before any action even made on our site, we offer you your initial deposit in Freebets, up to €100.": [
    null,
    "Antes mesmo de qualquer ação em nosso site, oferecemos a você o seu depósito inicial em Freebets, até 100 €."
  ],
  "Beginner": [
    null,
    ""
  ],
  "Beginner profile token": [
    null,
    ""
  ],
  "Beneficiary": [
    null,
    "Beneficiário"
  ],
  "Bet on sports": [
    null,
    "Apostar em esportes"
  ],
  "Betting limit - Poker": [
    null,
    ""
  ],
  "Betting limit - Sport betting": [
    null,
    ""
  ],
  "Birth date": [
    null,
    "Data de nascimento"
  ],
  "Birth name": [
    null,
    "Nome"
  ],
  "Bonus up to €250": [
    null,
    "Bônus de até €250"
  ],
  "Boom!": [
    null,
    "Bum!"
  ],
  "By ticking this box, you agree that you have read and accepted our": [
    null,
    "Ao clicar nesta opção, você concorda que leu e aceitou os nossos"
  ],
  "CAPTCHA score error. Please try again. You will automatically be redirected to the Winamax website. (%1$s)": [
    null,
    "Erro na pontuação CAPTCHA. Por favor, tente novamente. Você será automaticamente redirecionado para o site da Winamax. (%1$s)"
  ],
  "Card number": [
    null,
    "Número do cartão"
  ],
  "Change address": [
    null,
    "Modificar endereço"
  ],
  "Change my deposit limit": [
    null,
    "Modificar meu limite de depósito"
  ],
  "Change my limit": [
    null,
    "Modificar meu limite"
  ],
  "Change your account details in order to receive your activation code by post.": [
    null,
    "Altere os detalhes da sua conta para receber o seu código de ativação pelo correio."
  ],
  "Check that your bank card information is accurate and complete the cryptogram.": [
    null,
    "Verifique se os dados do seu cartão do banco estão corretos e preencha o criptograma."
  ],
  "Choose a deposit method in order to make your first deposit.": [
    null,
    "Escolha um método de depósito para fazer o seu primeiro depósito."
  ],
  "Choose a deposit method.": [
    null,
    "Escolha um método de depósito."
  ],
  "Choose the amount of your first deposit in order to start playing.": [
    null,
    "Defina o valor do seu primeiro depósito para começar a jogar."
  ],
  "Choose the amount you wish to deposit in order to continue playing.": [
    null,
    "Defina o valor que deseja depositar para continuar jogando."
  ],
  "Choose the maximum amount you wish to deposit per month.": [
    null,
    "Defina o valor máximo que você deseja depositar por mês."
  ],
  "Choose the maximum amount you wish to deposit per week.": [
    null,
    "Defina o valor máximo que você deseja depositar por semana."
  ],
  "Choose the profile that best suits your playing style! You can also change the values manually.": [
    null,
    ""
  ],
  "Choose which bank card you want to use to make a deposit.": [
    null,
    "Defina o cartão do banco que você deseja usar para fazer um depósito."
  ],
  "Choose your country code": [
    null,
    "Escolha o código do seu país"
  ],
  "Choose your limit well in order to take advantage of your <b>first bet refunded up to €100</b>": [
    null,
    "Escolha bem o seu limite para aproveitar o bônus."
  ],
  "Choose your username, but choose well!!<br />You need to have a kick-ass username to stand out in society.": [
    null,
    "Escolha seu nome de usuário, mas escolha bem!!<br />Você precisa ter um nome de usuário incrível para se destacar na sociedade."
  ],
  "Citizen card": [
    null,
    ""
  ],
  "Citizen card number": [
    null,
    ""
  ],
  "City": [
    null,
    "Cidade"
  ],
  "Click & drag your file here": [
    null,
    "Clique & arraste o seu documento para cá"
  ],
  "Close": [
    null,
    "Fechar"
  ],
  "Come and take a seat": [
    null,
    "Venha e sente-se"
  ],
  "Complete registration now": [
    null,
    "Concluir o seu cadastro agora"
  ],
  "Confirm limit": [
    null,
    "Confirmar limite"
  ],
  "Confirm my details": [
    null,
    "Confirmar meus dados"
  ],
  "Confirm my limit": [
    null,
    "Confirmar meu limite"
  ],
  "Confirm your details in order to receive a new activation code by post.": [
    null,
    "Confirme seus dados para receber um novo código de ativação pelo correio."
  ],
  "Continue": [
    null,
    "Continuar"
  ],
  "Continue my deposit": [
    null,
    "Continuar meu depósito"
  ],
  "Continue with PayPal": [
    null,
    "Continuar com PayPal"
  ],
  "Country": [
    null,
    "País"
  ],
  "Country of birth": [
    null,
    "País de nascimento"
  ],
  "Country of residence": [
    null,
    "País de residência"
  ],
  "Create my account": [
    null,
    "Criar minha conta"
  ],
  "Creation": [
    null,
    "Criação"
  ],
  "Cryptogram": [
    null,
    "Criptograma"
  ],
  "Deposit": [
    null,
    "Depósito"
  ],
  "Deposit limit": [
    null,
    "Limite de depósito"
  ],
  "Deposit on my account": [
    null,
    "Depositar na minha conta"
  ],
  "Deposit on your Winamax account by bank transfer": [
    null,
    "Depositar em sua conta Winamax por transferência bancária"
  ],
  "Deposit on your account with Neteller.": [
    null,
    "Depositar em sua conta com Neteller."
  ],
  "Deposit with Moneybookers/Skrill.": [
    null,
    "Depositar com Moneybookers/Skrill."
  ],
  "Document": [
    null,
    "Documento"
  ],
  "Document number": [
    null,
    "Número do documento"
  ],
  "Driver's licence": [
    null,
    "Carteira de motorista"
  ],
  "Driver's license": [
    null,
    "Carteira de motorista"
  ],
  "Driver's license: whole document with photo or front and back sides": [
    null,
    "Carteira de motorista: documento completo com foto"
  ],
  "Edit email/phone number": [
    null,
    "Modificar e-mail/número de telefone"
  ],
  "Email": [
    null,
    "E-mail"
  ],
  "Employed worker": [
    null,
    ""
  ],
  "Enter a different amount": [
    null,
    "Insira um valor diferente"
  ],
  "Enter amount": [
    null,
    "Inserir valor"
  ],
  "Enter my information": [
    null,
    "Inserir meus dados"
  ],
  "Enter the activation code sent to you by post.": [
    null,
    "Informe o código de ativação enviado para você pelo correio."
  ],
  "Enter the code sent by text message to %1$s to verify your phone number.": [
    null,
    "Informe o código enviado por mensagem de texto para %1$s para confirmar o seu número de telefone."
  ],
  "Experienced": [
    null,
    ""
  ],
  "Experienced profile token": [
    null,
    ""
  ],
  "Expiry date": [
    null,
    "Data de vencimento"
  ],
  "Feel free to discover the platform at a later date if you so wish.": [
    null,
    "Fique à vontade para descobrir a plataforma em uma futura ocasião, se preferir."
  ],
  "Female": [
    null,
    "Feminino"
  ],
  "Fill in my details": [
    null,
    "Preencher meus dados"
  ],
  "Fill out the following form. Or directly fill out the informations with Paypal": [
    null,
    "Preencha o formulário a seguir. Ou preencha diretamente suas informações com Paypal"
  ],
  "Fill out the form with your bank card information.": [
    null,
    "Preencha o formulário com os dados do seu cartão do banco."
  ],
  "First deposit": [
    null,
    "Primeiro depósito"
  ],
  "First name": [
    null,
    "Nome"
  ],
  "For a Spanish nationality, you must supply us with a DNI and not a NIE": [
    null,
    "Para uma nacionalidade espanhola, você deve nos fornecer um DNI e não um NIE"
  ],
  "For a foreign nationality, you must supply us with a NIE and not a DNI": [
    null,
    "Em caso de nacionalidade estrangeira, você pode nos fornecer o passaporte"
  ],
  "Free registration": [
    null,
    "Registro grátis"
  ],
  "Full name on card": [
    null,
    "Nome completo no cartão"
  ],
  "GG!<br />Your account has<br />been validated!": [
    null,
    "GG!<br />Sua conta<br />foi validada!"
  ],
  "Gambling is prohibited for minors": [
    null,
    "Os jogos de apostas são proibidos para menores de idade"
  ],
  "General Terms and Conditions": [
    null,
    "Termos e Condições gerais"
  ],
  "Health card: front and back": [
    null,
    "Cartão de saúde: frente e verso"
  ],
  "Hold on": [
    null,
    "Aguarde"
  ],
  "I accept the ": [
    null,
    "Eu aceito os "
  ],
  "I agree to gain access to all": [
    null,
    ""
  ],
  "I certify that I own this bank account": [
    null,
    ""
  ],
  "I have not received my code": [
    null,
    "Não recebi o meu código de ativação"
  ],
  "I have read and accept the": [
    null,
    ""
  ],
  "I need a new code": [
    null,
    "Preciso de um novo código"
  ],
  "I want to receive offers and news": [
    null,
    ""
  ],
  "I will deposit later": [
    null,
    "Vou depositar depois"
  ],
  "I will send it at a later time": [
    null,
    "Enviarei em outro momento"
  ],
  "IBAN": [
    null,
    "IBAN"
  ],
  "IBAN number": [
    null,
    ""
  ],
  "ID card: front and back": [
    null,
    "Carteira de identidade: frente e verso"
  ],
  "ID card: front side": [
    null,
    "Carteira de identidade: frente"
  ],
  "Identity card": [
    null,
    "Carteira de identidade"
  ],
  "Identity document number": [
    null,
    ""
  ],
  "Identity not verified": [
    null,
    "Identidade não verificada"
  ],
  "If you are not resident in Germany, you can register on": [
    null,
    "Se você não é residente na Alemanha, você pode se registrar em"
  ],
  "Important! Make sure you add the folloing reference for your transfer:": [
    null,
    "Importante! Certifique-se de incluir a seguinte referência para sua transferência:"
  ],
  "In 30 seconds": [
    null,
    "Em 30 segundos"
  ],
  "In order to make your deposit, add your bank card or any other deposit method.": [
    null,
    "Para fazer seu depósito, adicione o seu cartão do banco ou qualquer outro método de depósito."
  ],
  "In order to make your first deposit, add your bank card or any other deposit method.": [
    null,
    "Para fazer seu primeiro depósito, adicione o seu cartão do banco ou qualquer outro método de depósito."
  ],
  "In order to play for real money, you must send us a proof of address.": [
    null,
    "Para jogar com dinheiro real, você deve nos fornecer um comprovante de residência."
  ],
  "In order to play for real money, you must send us an ID.": [
    null,
    "Para jogar com dinheiro real, você deve nos fornecer um documento de identidade."
  ],
  "In order to validate your account, you must upload a photo of your ID.": [
    null,
    "Para validar sua conta, você deve enviar uma foto do seu documento de identidade."
  ],
  "Incorrect format in this field": [
    null,
    "Formato incorreto neste espaço"
  ],
  "Incorrect tax code": [
    null,
    "CPF incorreto"
  ],
  "Incorrect value in this field, the department does not match the city.": [
    null,
    "Informação incorreta neste espaço, o estado não corresponde à cidade."
  ],
  "Independent professional": [
    null,
    ""
  ],
  "Internal error": [
    null,
    "Erro interno"
  ],
  "Invalid NIE support number format. This must start with the letter \"E\" or \"C\" and be followed by 8 numbers.": [
    null,
    "Número de NIE em formato inválido. Ele deve começar com a letra \"E\" ou \"C\" e ser seguido por 8 números."
  ],
  "Invalid phone number format.": [
    null,
    "Formato de número de telefone inválido."
  ],
  "It seems there is a connection problem": [
    null,
    "Aparentemente, há um problema de conexão"
  ],
  "It would be a shame to stop so close to the finish line!": [
    null,
    ""
  ],
  "It's time to get serious": [
    null,
    "Chegou a hora de levar a sério"
  ],
  "Join Winamax and take advantage of our welcome offer!": [
    null,
    "Registre-se na Winamax e aproveite a nossa oferta de boas-vindas!"
  ],
  "Keep an <br />eye on your<br />dough!": [
    null,
    "Fique<br />de olho na sua<br />grana!"
  ],
  "Last name": [
    null,
    "Sobrenome"
  ],
  "Last<br />sprint!": [
    null,
    "Último <br />sprint!"
  ],
  "Leave": [
    null,
    "Sair"
  ],
  "Leave registration": [
    null,
    ""
  ],
  "Leaving us already?": [
    null,
    ""
  ],
  "Loading...": [
    null,
    "Carregando..."
  ],
  "Log in": [
    null,
    "Fazer login"
  ],
  "Make a deposit": [
    null,
    "Fazer um depósito"
  ],
  "Male": [
    null,
    "Masculino"
  ],
  "Maximum amount per month": [
    null,
    "Valor máximo por mês"
  ],
  "Maximum amount per week": [
    null,
    "Valor máximo por semana"
  ],
  "Missing application initialization parameters. Please try again.": [
    null,
    "Estão faltando parâmetros de inicialização do aplicativo. Por favor, tente novamente."
  ],
  "Moneybookers email": [
    null,
    "E-mail Moneybookers"
  ],
  "Must contain at least 3 of the following characters: (0-9), (a-z), (A-Z) and symbols (ex @, !, #, $).": [
    null,
    "Deve conter pelo menos 3 dos seguintes caracteres: (0-9), (a-z), (A-Z) e símbolos (ex @, !, #, $)."
  ],
  "NIE number": [
    null,
    "Número NIE"
  ],
  "Nationality": [
    null,
    "Nacionalidade"
  ],
  "Neteller Secure ID": [
    null,
    "Neteller ID segura"
  ],
  "Neteller account": [
    null,
    "Conta Neteller"
  ],
  "No godfather found for this code": [
    null,
    ""
  ],
  "No minors": [
    null,
    "Não é permitido para menores"
  ],
  "Occupation": [
    null,
    ""
  ],
  "Ok": [
    null,
    "Ok"
  ],
  "Oops,": [
    null,
    "Ops,"
  ],
  "Open your account": [
    null,
    "Abrir sua conta"
  ],
  "Optional": [
    null,
    "Opcional"
  ],
  "Other": [
    null,
    ""
  ],
  "Other deposit methods": [
    null,
    "Outros métodos de depósito"
  ],
  "Other document": [
    null,
    ""
  ],
  "Other suggestions": [
    null,
    "Outras sugestões"
  ],
  "Our bank details for your transfer:": [
    null,
    "Nossos dados bancários para sua transferência:"
  ],
  "Passport": [
    null,
    "Passaporte"
  ],
  "Passport: whole page with photo": [
    null,
    "Passaporte: página inteira com foto"
  ],
  "Password": [
    null,
    "Palavra passe"
  ],
  "Per month": [
    null,
    "Por mês"
  ],
  "Per week": [
    null,
    "Por semana"
  ],
  "Personal information": [
    null,
    "Informação pessoal"
  ],
  "Phone number": [
    null,
    "Número de telefone"
  ],
  "Phone, internet, water, gas or electricity bills": [
    null,
    "Contas de telefone, internet, água, gás ou eletricidade"
  ],
  "Place of birth": [
    null,
    "Cidade de nascimento"
  ],
  "Play on the app !": [
    null,
    "Jogar no app!"
  ],
  "Play poker": [
    null,
    "Jogar poker"
  ],
  "Play time - Poker": [
    null,
    ""
  ],
  "Poker Terms and Conditions": [
    null,
    "Termos e Condições do poker"
  ],
  "Postal address": [
    null,
    "Endereço postal"
  ],
  "Postal code": [
    null,
    "CEP"
  ],
  "Privacy Policy": [
    null,
    "Política de Privacidade e Cookies"
  ],
  "Privacy and Cookies Policy": [
    null,
    ""
  ],
  "Processing": [
    null,
    "Processando"
  ],
  "Protect your behind!": [
    null,
    "Proteja atrás de você!"
  ],
  "Protect<br />your<br />behind!": [
    null,
    "Proteja<br />atrás de<br />você!"
  ],
  "Province": [
    null,
    "Província"
  ],
  "RIB key": [
    null,
    "Chave RIB"
  ],
  "Reference": [
    null,
    "Referência"
  ],
  "Referral": [
    null,
    ""
  ],
  "Referral code": [
    null,
    ""
  ],
  "Region of birth": [
    null,
    "Estado de nascimento"
  ],
  "Register": [
    null,
    ""
  ],
  "Register with my email": [
    null,
    "Registrar-se com meu e-mail"
  ],
  "Register with my phone number": [
    null,
    "Registrar-se com meu número de telefone"
  ],
  "Registration": [
    null,
    "Cadastro"
  ],
  "Registration complete!": [
    null,
    ""
  ],
  "Registration not allowed from this country of residence.": [
    null,
    "Inscrição não permitida a partir deste país de residência."
  ],
  "Regular": [
    null,
    ""
  ],
  "Regular profile token": [
    null,
    ""
  ],
  "Residence permit: front and back": [
    null,
    "Autorização de residência: frente e verso"
  ],
  "Responsible gaming": [
    null,
    "Jogo responsável"
  ],
  "Retired": [
    null,
    ""
  ],
  "SWIFT code": [
    null,
    "Código SWIFT"
  ],
  "Save this card for future deposits": [
    null,
    "Salvar este cartão para futuros depósitos"
  ],
  "Scan my ID": [
    null,
    "Escanear minha identidade"
  ],
  "Scan my bank card": [
    null,
    "Escanear meu cartão do banco"
  ],
  "Scan my verification document": [
    null,
    "Escanear meu documento de comprovação"
  ],
  "Search": [
    null,
    "Buscar"
  ],
  "See Ts&Cs for the offer": [
    null,
    "Consulte os T&Cs da oferta"
  ],
  "See accepted verification documents": [
    null,
    "Consulte os documentos de comprovação aceitos"
  ],
  "See what IDs we accept": [
    null,
    "Ver quais são os documentos de identidade aceitos"
  ],
  "Select your file": [
    null,
    "Selecione o seu documento"
  ],
  "Self-employed": [
    null,
    ""
  ],
  "Send ID": [
    null,
    "Enviar documento de identidade"
  ],
  "Send back of document": [
    null,
    "Enviar o verso do documento"
  ],
  "Send documents": [
    null,
    "Enviar documentos"
  ],
  "Send my ID": [
    null,
    "Enviar meu documento de identidade"
  ],
  "Send my new code": [
    null,
    "Enviar meu novo código"
  ],
  "Send my verification documents": [
    null,
    "Enviar meus documentos de comprovação"
  ],
  "Send proof of identity": [
    null,
    "Enviar comprovante de identidade"
  ],
  "Sex": [
    null,
    "Sexo"
  ],
  "Show<br />us who<br />you are!": [
    null,
    "Mostre<br />quem<br />você é!"
  ],
  "Skip this step": [
    null,
    "Pular esta etapa"
  ],
  "Skrill email": [
    null,
    "E-mail Skrill"
  ],
  "Social security card": [
    null,
    "Cartão de previdência social"
  ],
  "Sports betting Terms and Conditions": [
    null,
    "Termos e Condições das apostas esportivas"
  ],
  "Starting at €%1$s": [
    null,
    "A partir de €%1$s"
  ],
  "Student": [
    null,
    ""
  ],
  "Successfully uploaded!": [
    null,
    "Carregado com sucesso!"
  ],
  "Super-player created!": [
    null,
    "Superjogador criado!"
  ],
  "Surname": [
    null,
    "Sobrenome"
  ],
  "Take 2 minutes to create your account.": [
    null,
    "Dedique 2 minutos para criar a sua conta."
  ],
  "Tax Code": [
    null,
    "CPF"
  ],
  "Tax bill or home insurance letter": [
    null,
    "Declaração de imposto de renda ou apólice de seguro residencial"
  ],
  "Terms and Conditions": [
    null,
    "Termos e Condições"
  ],
  "The activation code cannot be over %1$s characters.": [
    null,
    "O código de ativação não pode ter mais de %1$s caracteres."
  ],
  "The activation code is not valid.": [
    null,
    "O código de ativação não é válido."
  ],
  "The best odds are your odds": [
    null,
    "As melhores cotas são as suas cotas"
  ],
  "The current process seems to be slow. Try again.": [
    null,
    "O atual processo parece estar lento. Tente novamente."
  ],
  "The identity verification service is unavailable. Please try again later.": [
    null,
    "O serviço de verificação de identidade está indisponível. Por favor, tente novamente mais tarde."
  ],
  "The maximum amount of time (in hours) you can spend at the poker tables each week.": [
    null,
    ""
  ],
  "The maximum amount you can deposit into your account each week for sports betting and poker.": [
    null,
    ""
  ],
  "The maximum cumulative amount you can bet on poker each week.": [
    null,
    ""
  ],
  "The maximum cumulative amount you can bet on sports betting each week.": [
    null,
    ""
  ],
  "The registration process is only available for Portuguese citizens.": [
    null,
    ""
  ],
  "The welcome bonus is linked to your first deposit. Set an amount of €100 (or more) to maximise your bonus!": [
    null,
    ""
  ],
  "There already exists an account with this email address.": [
    null,
    "Já existe uma conta com este endereço de e-mail."
  ],
  "These deposit methods are not available for this amount.": [
    null,
    "Estes métodos de depósito não estão disponíveis para este valor."
  ],
  "This code is required to create your account.": [
    null,
    "Este código é indispensável para criar a sua conta."
  ],
  "This document must mention your name and IBAN number.": [
    null,
    ""
  ],
  "This field is mandatory to validate your deposit.": [
    null,
    "Esse campo é obrigatório para validar seu depósito."
  ],
  "This file format is invalid. Please try in one of the following formats: %1$s.": [
    null,
    "Este formato de documento é inválido. Por favor, tente usar um dos seguintes formatos: %1$s."
  ],
  "This fiscal code is already linked to an active account": [
    null,
    "Este CPF já está vinculado a uma conta ativa"
  ],
  "This limit can be changed at any time in your account.": [
    null,
    ""
  ],
  "This limit is mandatory for your account validation.": [
    null,
    "Este limite é obrigatório para a validação da sua conta."
  ],
  "This password does not contain at least 3 of the following: (0-9), (a-z), (A-Z) and symbols (e.g. @, !, #, $)": [
    null,
    "Esta senha não contém o mínimo de 3 dos seguintes caracteres: (0-9), (a-z), (A-Z) e símbolos (por exemplo, @, !, #, $)"
  ],
  "This referral code is not valid.": [
    null,
    ""
  ],
  "This threshold can be changed at any time from your account.": [
    null,
    ""
  ],
  "This username is unavailable.": [
    null,
    "Este nome de usuário não está disponível."
  ],
  "This way for<br />money": [
    null,
    "Nesta direção para<br />dinheiro"
  ],
  "To finish your account validation, please upload a proof of bank account's property.": [
    null,
    ""
  ],
  "Too many attempts with this identity. Please try again later.": [
    null,
    "Muitas tentativas com esta identidade. Por favor, tente novamente mais tarde."
  ],
  "Trainee": [
    null,
    ""
  ],
  "Try again": [
    null,
    "Tente novamente"
  ],
  "Ts&Cs": [
    null,
    "T&Cs"
  ],
  "Ts&Cs for the offer": [
    null,
    "T&Cs da oferta"
  ],
  "Type of cash-out": [
    null,
    "Tipo de saque"
  ],
  "Type of document": [
    null,
    "Tipo de documento"
  ],
  "Unable to load profile information.": [
    null,
    "Não foi possível carregar as informações do perfil."
  ],
  "Unable to send verification message.": [
    null,
    "Não foi possível enviar a mensagem de verificação."
  ],
  "Unauthorised email.": [
    null,
    "Seu e-mail não está autorizado."
  ],
  "Unemployed": [
    null,
    ""
  ],
  "Up to": [
    null,
    "Até"
  ],
  "Up to a limit of €100 or the same amount as your first deposit": [
    null,
    ""
  ],
  "Up to €100 free, instantly!": [
    null,
    "Até €100 grátis, instantaneamente!"
  ],
  "Upload an identity document to continue registration.": [
    null,
    ""
  ],
  "Upload my ID": [
    null,
    "Carregar minha identidade"
  ],
  "Upload my verification document": [
    null,
    "Carregar meu documento de comprovação"
  ],
  "Upload your bank document": [
    null,
    ""
  ],
  "Use France Connect": [
    null,
    "Usar France Connect"
  ],
  "Use my existing deposit limit. If none is available, the limit set by you above will be applied.": [
    null,
    ""
  ],
  "Used or married name": [
    null,
    "Nome de casado"
  ],
  "Username": [
    null,
    "Nome de usuário"
  ],
  "Validate": [
    null,
    "Validar"
  ],
  "Validate my deposit": [
    null,
    "Validar meu depósito"
  ],
  "Validate my information": [
    null,
    "Validar minhas informações"
  ],
  "Validate my limit": [
    null,
    "Validar meu limite"
  ],
  "Validate my username": [
    null,
    "Validar meu nome de usuário"
  ],
  "Validation code": [
    null,
    "Código de validação"
  ],
  "Verification": [
    null,
    "Verificação"
  ],
  "Verify your phone number to receive a new text message with your validation code.": [
    null,
    "Verifique seu número de telefone para receber uma nova mensagem de texto com o seu código de validação."
  ],
  "Want to start playing? Make a deposit now.": [
    null,
    "Quer começar a jogar? Faça um depósito agora."
  ],
  "Want to<br />create a<br />username?": [
    null,
    "Deseja<br />criar um<br />nome de usuário?"
  ],
  "We are also offering a bonus of equal value to your first deposit.": [
    null,
    "Também estamos oferecendo um bônus de valor equivalente ao seu primeiro depósito."
  ],
  "We cannot accept land-line numbers.": [
    null,
    "Não aceitamos números de telefone fixo."
  ],
  "We will refund your 1st bet up to €100.": [
    null,
    "Vamos reembolsar sua primeira aposta em até €100."
  ],
  "We're fetching your data...": [
    null,
    "Estamos buscando seus dados..."
  ],
  "We're missing your identity documents to complete your registration.": [
    null,
    ""
  ],
  "Weekly betting limits": [
    null,
    ""
  ],
  "Welcome bonus": [
    null,
    ""
  ],
  "Welcome to Winamax": [
    null,
    ""
  ],
  "Welcome<br />to<br />Winamax!": [
    null,
    "Bem-vindo<br />à<br />Winamax!"
  ],
  "What is France Connect": [
    null,
    "O que é France Connect"
  ],
  "With 168h per week, you can play for an unlimited period": [
    null,
    ""
  ],
  "Withdrawable cash credited to your account directly after the result of the first bet": [
    null,
    ""
  ],
  "Without a professional activity": [
    null,
    ""
  ],
  "You are already registered.": [
    null,
    "Você já está registrado."
  ],
  "You are not authorized to access this service.": [
    null,
    "Você não tem autorização para acessar este serviço."
  ],
  "You are not permitted to create an account from this country.": [
    null,
    "Você não tem permissão para criar uma conta neste país."
  ],
  "You are not permitted to create this user account.": [
    null,
    "Você não tem permissão para criar esta conta de usuário."
  ],
  "You are on the Interior Ministry's banned player list!": [
    null,
    "Você está na lista de jogadores proibidos pelo Ministério do Interior!"
  ],
  "You can change this option at any time from your account": [
    null,
    ""
  ],
  "You can continue playing on Winamax in the meantime.": [
    null,
    "Você pode continuar jogando na Winamax enquanto isso."
  ],
  "You can deposit now to discover our poker and sports betting offer!": [
    null,
    ""
  ],
  "You can finally risk it for that big accumulator!": [
    null,
    "Você pode finalmente arriscar aquela grande combinada!"
  ],
  "You can only upload one file at a time. Choose wisely!": [
    null,
    "Você só pode fazer upload de um documento de cada vez. Escolha bem!"
  ],
  "You can send this to us at a later time, but you must enter your information now.": [
    null,
    "Você pode nos enviar isto mais tarde, mas deve fornecer seus dados pessoais agora."
  ],
  "You cannot create an account from your country.": [
    null,
    "Não é possível criar uma conta no seu país."
  ],
  "You have already transferred this file.": [
    null,
    "Você já transferiu este documento."
  ],
  "You have entered an invalid domiciliation code": [
    null,
    "Você inseriu um CEP inválido"
  ],
  "You have entered an invalid phone number.": [
    null,
    "Você inseriu um número de telefone inválido."
  ],
  "You have insufficient CAPTCHA score to continue. Please try again later.": [
    null,
    "Sua pontuação CAPTCHA é insuficiente para continuar. Tente novamente mais tarde."
  ],
  "You have successfully added your identity document. Please ensure the information you have entered is correct and fill out your postal address.": [
    null,
    "Você inseriu seu documento de identidade com sucesso. Verifique se os dados informados estão corretos e preencha seu endereço postal."
  ],
  "You have successfully made a request to change your password. Please check your emails.": [
    null,
    "Sua solicitação para alterar a senha foi realizada com sucesso. Por favor, verifique seus e-mails."
  ],
  "You must accept our Ts&Cs in order to create your account.": [
    null,
    "Você precisa aceitar os nossos Termos & Condições para criar a sua conta."
  ],
  "You must certify that you own this bank account.": [
    null,
    ""
  ],
  "You must choose a betting stakes limit in order to start playing.": [
    null,
    ""
  ],
  "You must choose a deposit limit in order to make a deposit.": [
    null,
    "Você deve escolher um limite de depósito para poder fazer um depósito."
  ],
  "You must choose a password.": [
    null,
    "Você deve criar uma senha."
  ],
  "You must choose a playtime limit in order to start playing.": [
    null,
    ""
  ],
  "You must choose a poker stakes limit in order to start playing.": [
    null,
    ""
  ],
  "You must choose an automatic withdrawal limit in order to start playing.": [
    null,
    ""
  ],
  "You must choose an option for your sex in order to create your account.": [
    null,
    "Você deve escolher uma opção de sexo para criar a sua conta."
  ],
  "You must enter a deposit amount.": [
    null,
    "Você deve inserir um valor de depósito."
  ],
  "You must enter an email or a phone number.": [
    null,
    "Você deve inserir um e-mail ou um número de telefone."
  ],
  "You must enter an iban number.": [
    null,
    ""
  ],
  "You must enter the full name displayed on your bank card in order to validate your deposit.": [
    null,
    "Você deve informar o nome completo que consta em seu cartão do banco para validar o seu depósito."
  ],
  "You must enter your activation code in order to validate your account.": [
    null,
    "Você deve informar o seu código de ativação para validar a sua conta."
  ],
  "You must enter your bank card cryptogram in order to validate your deposit.": [
    null,
    "Você deve informar o criptograma do seu cartão do banco para validar o seu depósito."
  ],
  "You must enter your bank card expiry date in order to validate your deposit.": [
    null,
    "Você deve informar a data de vencimento do seu cartão do banco para validar o seu depósito."
  ],
  "You must enter your bank card number in order to validate your deposit.": [
    null,
    "Você deve informar o número do seu cartão do banco para validar o seu depósito."
  ],
  "You must enter your city of birth in order to create your account.": [
    null,
    "Você deve informar sua cidade de nascimento para criar a sua conta."
  ],
  "You must enter your city of residence in order to create your account.": [
    null,
    "Você deve informar sua cidade de residência para criar a sua conta."
  ],
  "You must enter your country of birth in order to create your account.": [
    null,
    "Você deve informar seu país de nascimento para criar a sua conta."
  ],
  "You must enter your country of residence in order to create your account.": [
    null,
    "Você deve informar seu país de residência para criar a sua conta."
  ],
  "You must enter your date of birth in order to create your account.": [
    null,
    "Você deve fornecer a sua data de nascimento para criar a sua conta."
  ],
  "You must enter your department of birth in order to create your account.": [
    null,
    "Você deve informar seu estado de nascimento para criar a sua conta."
  ],
  "You must enter your email in order to create your account.": [
    null,
    "Você deve informar seu e-mail para criar a sua conta."
  ],
  "You must enter your identity document number.": [
    null,
    "Você deve inserir o número do seu documento de identidade."
  ],
  "You must enter your phone number in order to create your account.": [
    null,
    "Você deve fornecer o seu número de telefone para criar a sua conta."
  ],
  "You must enter your postal address in order to create your account.": [
    null,
    "Você deve informar seu endereço postal para criar a sua conta."
  ],
  "You must enter your postal code in order to create your account.": [
    null,
    "Você deve informar seu CEP para criar a sua conta."
  ],
  "You must enter your province to create your account.": [
    null,
    "Você deve informar sua província para criar sua conta."
  ],
  "You must not be connected to the Winamax Poker software (desktop or mobile)": [
    null,
    "Você não deve estar conectado ao software Winamax Poker (desktop ou celular)"
  ],
  "You must provide your first name in order to create your account.": [
    null,
    "Você deve fornecer o seu nome para poder criar a sua conta."
  ],
  "You must provide your last name in order to create your account.": [
    null,
    "Você deve fornecer o seu sobrenome para poder criar a sua conta."
  ],
  "You must provide your second last name in order to create your account.": [
    null,
    "Você deve fornecer seu segundo sobrenome para criar a sua conta."
  ],
  "You must upload your bank document.": [
    null,
    ""
  ],
  "You need a username to play on Winamax.": [
    null,
    "Você precisa de um nome de usuário para jogar na Winamax."
  ],
  "You need to provide us with your ID and proof of address in order to complete your registration.": [
    null,
    "Você precisa nos apresentar um documento de identidade e comprovante de residência para concluir o seu registro."
  ],
  "You need to provide us with your ID in order to complete your registration.": [
    null,
    "Você precisa nos fornecer um documento de identidade para concluir o seu registro."
  ],
  "You will receive an activation code by post at the following address:": [
    null,
    "Você receberá um código de ativação pelo correio no seguinte endereço:"
  ],
  "You're too old!": [
    null,
    "Você está velho demais!"
  ],
  "You're too young!": [
    null,
    "Você é muito jovem!"
  ],
  "You're way too young!": [
    null,
    "Você é jovem demais!"
  ],
  "Your ID upload has encountered an error": [
    null,
    "O upload do seu documento de identidade encontrou um erro"
  ],
  "Your ID was registered successfully": [
    null,
    "Seu documento de identidade foi registrado com sucesso"
  ],
  "Your account is being validated. You will receive a notification once your documents have been verified.": [
    null,
    ""
  ],
  "Your account is frozen.": [
    null,
    "A sua conta está bloqueada."
  ],
  "Your account is reloaded,<br /><b>you can continue playing on Winamax</b>": [
    null,
    "Sua conta está recarregada,<br /><b>você pode continuar jogando na Winamax</b>"
  ],
  "Your account validation is being processed. You will be notified when your documents have been validated.": [
    null,
    "A validação da sua conta está sendo processada. Você será notificado quando seus documentos forem aprovados."
  ],
  "Your address is not valid.": [
    null,
    "Seu endereço é inválido."
  ],
  "Your automatic withdrawal limit cannot be over %1$s digits.": [
    null,
    "Seu limite de saque automático não pode ser superior a %1$s dígitos."
  ],
  "Your automatic withdrawal limit is too big.": [
    null,
    ""
  ],
  "Your automatic withdrawal limit must be greater than or equal to your deposit limit.": [
    null,
    ""
  ],
  "Your automatic withdrawal limit must be more than €200.": [
    null,
    ""
  ],
  "Your automatic withdrawal limit must be over €0.": [
    null,
    "Seu limite de saque automático deve ser superior a €0."
  ],
  "Your bank card cryptogram is not valid.": [
    null,
    "O criptograma do seu cartão do banco não é válido."
  ],
  "Your bank card expiry date is not valid.": [
    null,
    "A data de vencimento do seu cartão do banco não é válida."
  ],
  "Your bank card number is not valid": [
    null,
    "O número do seu cartão do banco não é válido"
  ],
  "Your bet refunded in": [
    null,
    ""
  ],
  "Your betting stakes limit is too big.": [
    null,
    ""
  ],
  "Your betting stakes limit must be more than €0.": [
    null,
    ""
  ],
  "Your betting stakes limit per week is not valid.": [
    null,
    "Seu limite semanal de apostas esportivas é inválido."
  ],
  "Your city cannot be over %1$s characters.": [
    null,
    "Sua cidade não pode ter mais de %1$s caracteres."
  ],
  "Your city is not valid.": [
    null,
    "Sua cidade é inválida."
  ],
  "Your city is required.": [
    null,
    "Sua cidade é obrigatória."
  ],
  "Your city of birth cannot be over %1$s characters.": [
    null,
    "Sua cidade de nascimento não pode ter mais de %1$s caracteres."
  ],
  "Your city of birth is not valid.": [
    null,
    "Sua cidade de origem é inválida."
  ],
  "Your coordinates": [
    null,
    "Seus dados"
  ],
  "Your country cannot be over %1$s characters.": [
    null,
    "Seu país não pode ter mais de %1$s caracteres."
  ],
  "Your country is not valid.": [
    null,
    "Seu país é inválido."
  ],
  "Your country is required.": [
    null,
    "Seu país é obrigatório."
  ],
  "Your country of birth is not valid.": [
    null,
    "Seu país de origem é inválido."
  ],
  "Your date of birth is not valid.": [
    null,
    "Sua data de nascimento é inválida."
  ],
  "Your date of birth must include 4 numbers.": [
    null,
    "Sua data de nascimento deve conter 4 números."
  ],
  "Your department of birth cannot be over %1$s characters.": [
    null,
    "Seu estado de nascimento não pode ter mais de %1$s caracteres."
  ],
  "Your department of birth is not valid.": [
    null,
    "Seu estado de origem é inválido."
  ],
  "Your deposit cannot be more than your weekly deposit limit: €%1$s.": [
    null,
    "Seu depósito não pode ser maior do que o seu limite de depósito semanal: €%1$s."
  ],
  "Your deposit limit has been registered. <b>in 48 hours, you will be able to make larger deposits</b>": [
    null,
    "Seu limite de depósito foi registrado.<b>em 48 horas, você poderá fazer depósitos maiores</b>"
  ],
  "Your deposit limit is too big.": [
    null,
    "Seu limite de depósito é muito alto."
  ],
  "Your deposit limit must be more than €0.": [
    null,
    "Seu limite de depósito deve ser superior a €0."
  ],
  "Your deposit limit per week is not valid.": [
    null,
    "Seu limite semanal de depósito é inválido."
  ],
  "Your deposit must be over €0.": [
    null,
    "Seu depósito deve ser superior a €0."
  ],
  "Your document failed to upload": [
    null,
    "Seu documento falhou ao ser carregado"
  ],
  "Your email cannot be over %1$s characters.": [
    null,
    "Seu e-mail não pode ter mais de %1$s caracteres."
  ],
  "Your email is not valid.": [
    null,
    "Seu e-mail não é válido."
  ],
  "Your file is too big. Try again with a file smaller than %1$s Mb.": [
    null,
    "Seu documento é muito grande. Tente novamente com um documento de tamanho menor que %1$s Mb."
  ],
  "Your first bet refunded in cash if it loses": [
    null,
    ""
  ],
  "Your first name cannot be over %1$s characters.": [
    null,
    "Seu nome não pode ter mais de %1$s caracteres."
  ],
  "Your first name is not valid.": [
    null,
    "Seu nome é inválido."
  ],
  "Your identity": [
    null,
    "Sua identidade"
  ],
  "Your identity corresponds to that of a minor.": [
    null,
    "A sua identidade corresponde à de uma pessoa menor de idade."
  ],
  "Your identity corresponds to that of someone who has been registered as being deceased.": [
    null,
    "Sua identidade corresponde à de alguém que foi registrado como já falecido."
  ],
  "Your information is being processed!": [
    null,
    "Suas informações estão sendo processadas!"
  ],
  "Your initial deposit in Freebets, up to €100*": [
    null,
    "Seu depósito inicial em Freebets, até €100*"
  ],
  "Your last name cannot be over %1$s characters.": [
    null,
    "Seu sobrenome não pode ter mais de %1$s caracteres."
  ],
  "Your last name is not valid.": [
    null,
    "Seu sobrenome é inválido."
  ],
  "Your limit cannot be €0": [
    null,
    "Seu limite não pode ser €0"
  ],
  "Your limit for %1$s must be inferior or equal to %2$s": [
    null,
    ""
  ],
  "Your limit for %1$s must be set between %2$s and %3$s": [
    null,
    ""
  ],
  "Your limit for %1$s must be superior or equal to %2$s": [
    null,
    ""
  ],
  "Your limit for %1$s must be superior or equal to your %2$s limit": [
    null,
    ""
  ],
  "Your limit must be inferior or equal to %1$s": [
    null,
    "Seu limite deve ser inferior ou igual a %1$s"
  ],
  "Your limit must be set between %1$s and %2$s": [
    null,
    "Seu limite deve ser definido entre %1$s e %2$s"
  ],
  "Your limit must be superior or equal to %1$s": [
    null,
    "Seu limite deve ser superior ou igual a %1$s"
  ],
  "Your name in the rankings will be:": [
    null,
    "Seu nome nas tabelas de classificação será:"
  ],
  "Your number will only be used to identify you": [
    null,
    "Seu número será usado apenas para identificação"
  ],
  "Your password cannot be over %1$s characters.": [
    null,
    "Sua senha não deve conter mais de %1$s caracteres."
  ],
  "Your password is not valid.": [
    null,
    "Sua senha não é válida."
  ],
  "Your password must contain at least %1$s characters.": [
    null,
    "Sua senha deve conter pelo menos %1$s caracteres."
  ],
  "Your payment": [
    null,
    "Seu pagamento"
  ],
  "Your phone number is mandatory in order to receive a new code.": [
    null,
    "Seu número de telefone é indispensável para receber um novo código."
  ],
  "Your playtime limit must be more than 0 hours.": [
    null,
    ""
  ],
  "Your poker stakes limit is too big.": [
    null,
    ""
  ],
  "Your poker stakes limit must be more than €0.": [
    null,
    ""
  ],
  "Your poker stakes limit per week is not valid.": [
    null,
    "Seu limite semanal de apostas no poker é inválido."
  ],
  "Your postal address cannot be over %1$s characters.": [
    null,
    "Seu endereço postal não pode ter mais de %1$s caracteres."
  ],
  "Your postal address is required.": [
    null,
    "Seu endereço postal é obrigatório."
  ],
  "Your postal code cannot be over %1$s characters.": [
    null,
    "Seu CEP não pode ter mais de %1$s caracteres."
  ],
  "Your postal code is required.": [
    null,
    "Seu CEP é obrigatório."
  ],
  "Your proof of address cannot be over one year old.": [
    null,
    "Seu comprovante de residência não pode ter mais de um ano."
  ],
  "Your session has expired.": [
    null,
    "Sua sessão expirou."
  ],
  "Your state is not valid.": [
    null,
    "Seu estado é inválido."
  ],
  "Your story begins here!": [
    null,
    ""
  ],
  "Your turn to play": [
    null,
    "Sua vez de jogar"
  ],
  "Your turn<br />to play": [
    null,
    "Sua vez<br />de jogar"
  ],
  "Your username cannot contain over %1$s characters.": [
    null,
    "Seu nome de usuário não pode conter mais de %1$s caracteres."
  ],
  "Your username is not valid, the only authorized special characters are: .&_- and space.": [
    null,
    "Seu nome de usuário não é válido, os únicos caracteres especiais autorizados são: .&_- e espaço."
  ],
  "Your username must contain at least %1$s characters.": [
    null,
    "Seu nome de usuário deve conter pelo menos %1$s caracteres."
  ],
  "Your validation code is incorrect.": [
    null,
    "Seu código de validação está incorreto."
  ],
  "Your zip code is not valid.": [
    null,
    "Seu CEP é inválido."
  ],
  "Your zip code of birth is not valid.": [
    null,
    "Seu CEP de nascimento não é válido."
  ],
  "and": [
    null,
    ""
  ],
  "and the": [
    null,
    ""
  ],
  "as well as our": [
    null,
    "assim como nossa"
  ],
  "is being processed...": [
    null,
    "está sendo processado..."
  ],
  "of a super-player in progress...": [
    null,
    "de um superjogador em andamento..."
  ],
  "of the ongoing payment...": [
    null,
    "do pagamento em andamento..."
  ],
  "of your bank card processing...": [
    null,
    "do seu cartão do banco está processando..."
  ],
  "or": [
    null,
    "ou"
  ],
  "poker": [
    null,
    ""
  ],
  "promotions": [
    null,
    ""
  ],
  "sports betting": [
    null,
    ""
  ],
  "your document upload...": [
    null,
    "seu upload de documentos..."
  ]
}
  }
}
